import { forwardRef, InputHTMLAttributes } from 'react'

interface ToggleProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string
}

export const Toggle = forwardRef<HTMLInputElement, ToggleProps>(
  ({ label, className = '', id, ...props }, ref) => {
    const toggleId = id || label?.toLowerCase().replace(/\s+/g, '-')

    return (
      <label htmlFor={toggleId} className={`flex items-center gap-3 cursor-pointer ${className}`}>
        <div className="relative">
          <input
            ref={ref}
            type="checkbox"
            id={toggleId}
            className="sr-only peer"
            {...props}
          />
          <div className="w-10 h-6 bg-border rounded-full peer-checked:bg-primary-text transition-colors" />
          <div className="absolute top-1 left-1 w-4 h-4 bg-primary-bg rounded-full transition-transform peer-checked:translate-x-4" />
        </div>
        {label && <span className="text-sm">{label}</span>}
      </label>
    )
  }
)

Toggle.displayName = 'Toggle'
